// React
import React from 'react';

export const ItemListDependent = ({
  item,
  index,
  isView,
  handleChangeDependents,
}) => {
  const convertDateToBrazilFormat = (date) => {
    if (date !== null) {
      const [year, month, day] = date.split('-');

      return [day, month, year].join('/');
    }
    return null;
  };

  return (
    <tr
      id={index}
      key={index}
      style={{
        lineHeight: 1,
      }}
    >
      <td>{index !== undefined ? index + 1 : ''}</td>
      <td className="text-start">{item.cpf || '-'}</td>
      <td className="text-start">
        <span
          className="fw-normal"
          style={{
            position: 'relative',
            bottom: 3,
          }}
        >
          {item.name}
        </span>{' '}
        <br />
        <span className="text-muted mt-2 fw-normal">{item.card_number}</span>
      </td>
      <td className="text-start">
        {convertDateToBrazilFormat(item.birthdate) || '-'}
      </td>
      <td className="text-start">
        {item.gender === 'M' && 'Masculino'}
        {item.gender === 'F' && 'Feminino'}
      </td>
      <td className="text-start">{item.kinship_name || '-'}</td>
      <td>
        {item.funeral_assistance ? (
          <span className="badge badge-soft-success">Sim</span>
        ) : (
          <span className="badge badge-soft-danger">Não</span>
        )}
      </td>

      <td>
        {!isView && (
          <div className="hstack gap-3 fs-15">
            <div
              to="#"
              className="link-primary"
              onClick={() => {
                handleChangeDependents();
              }}
              style={{
                cursor: 'pointer',
              }}
            >
              <i className="ri-settings-4-line"></i>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
};
